module.exports = __webpack_public_path__ + "c99a5055ae56c7a2dfcf8f7fc8d3199c.jpg";